function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { input } from '../../../theme/utils/form.utils';
export var selectTheme = {
  baseStyle: {
    control: _objectSpread(_objectSpread({}, input.field), {}, {
      display: 'flex',
      paddingBottom: 'xxxs',
      '&[data-focus="true"]': {
        border: 'input.brand'
      },
      '&[data-focus="true"]:hover': {
        border: 'input.brand'
      }
    }),
    menuList: {
      textStyle: 'body2',
      width: '100%',
      borderRadius: 'l',
      shadow: 500,
      border: 'surface.default',
      bgColor: 'neutral.white',
      overflowY: 'auto',
      maxHeight: '320px',
      paddingY: 'xs'
    },
    valueContainer: {
      textStyle: 'body2',
      border: 'none',
      alignItems: 'center',
      display: 'grid',
      flex: 1,
      flexWrap: 'wrap',
      position: 'relative',
      overflow: 'hidden',
      // This is an override to Input from react-select
      '[data-value]': {
        padding: 'none',
        margin: 'none'
      },
      // This resolves a hard-to-reproduce bug
      '[data-value] > input': {
        backgroundColor: 'transparent !important'
      }
    },
    singleValue: {
      gridArea: '1/1/2/3'
    },
    placeholder: {
      textStyle: 'body2',
      border: 'none',
      gridArea: '1/1/2/3',
      color: 'neutral.dark',
      marginRight: 'xxxs',
      _disabled: _objectSpread(_objectSpread({}, input.field._disabled), {}, {
        border: 'none'
      })
    },
    creatableMessage: {
      display: 'flex',
      alignItems: 'center',
      gridGap: 'xs',
      textStyle: 'body3',
      '& p': {
        display: 'inline-block'
      }
    }
  },
  defaultProps: {
    size: 'large'
  }
};
//# sourceMappingURL=_Select.theme.js.map